import "./DataPathSelectPopover.0.css";
import { INJECT_UICORE_DESIGNER, NO_OP } from "../../lib/utils/consts";
import { getOffsetRect, getPopupPosition } from "../../lib/utils/styling";
import GlobalClickGuard from "./GlobalClickGuard";
import UcdDataSourceTree from "./DataSourceTree/index";
import DSTreeNode from './DataSourceTree/DSTreeNode';
import { vueLinkLocalStorage } from "../../lib/utils/vue";
import { joinPath, toPathParts } from '@tencent/data-schema-core/lib/utils/path';
import { delay } from "../../lib/utils";
const __script_base__ = {
  name: 'UcDataPathSelectPopover',
  components: {
    GlobalClickGuard,
    UcdDataSourceTree,
    DSTreeNode
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      shown: false,
      x: 0,
      y: 0,
      width: 0,
      searchKey: '',
      // 选项

      showOriginalName: false,
      showAllNodes: false,
      // 下面这些是来自 OpenDataPathSelectorOptions 的

      currentDataPath: '',
      userCustomFilter: null,
      selectorOnly: false,
      creating: false
    };
  },
  created() {
    vueLinkLocalStorage(this, 'ucDataPathSelectPopover', 'showOriginalName');
  },
  computed: {
    filteredDataSource() {
      const checkData = !this.showAllNodes && this.userCustomFilter;
      const searchKey = this.searchKey.toLowerCase();
      return ({
        schema,
        searchKeywords
      }) => {
        if (checkData && !checkData(schema)) return false;
        if (searchKey && !searchKeywords.includes(searchKey)) return false;
        return true;
      };
    },
    displayCreateButton() {
      // 空输入框 && 合法JS标识符
      return !this.currentDataPath || /^\w+$/.test(this.currentDataPath);
    }
  },
  methods: {
    checkBindableOfTreeNode(node) {
      if (node.stub.schema['uc:bindable'] === false) return false;
      const checkData = !this.showAllNodes && this.userCustomFilter;
      if (checkData && !checkData(node.stub.schema)) return false;
      return true;
    },
    async locateCurrentNode() {
      const dataPathParts = toPathParts(this.currentDataPath);
      await this.$nextTick();
      for (let i = 0; i < dataPathParts.length; i++) {
        const tempPath = joinPath(dataPathParts.slice(0, i + 1));
        const treeNode = this.$refs[`node:${tempPath}`];
        if (!treeNode) return;
        if (i === dataPathParts.length - 1) {
          treeNode.$el.scrollIntoView({
            block: 'end',
            inline: 'nearest'
          });
        } else {
          if (!treeNode.$parent.expanded) {
            treeNode.$parent.expanded = true;
            await this.$nextTick();
          }
        }
      }
    },
    handleTreeNodeClick(node) {
      if (!this.checkBindableOfTreeNode(node)) return;
      const newPath = node.dataPath;
      if (this.selectorOnly) {
        this.resolve(newPath);
        return;
      }
      if (this.currentDataPath === newPath) this.resolve(newPath);else this.currentDataPath = newPath;
    },
    /**
     * 交修改
     *
     * @param { null | string } value
     */
    resolve(value) {
      var _this$actualResolve;
      (_this$actualResolve = this.actualResolve) === null || _this$actualResolve === void 0 || _this$actualResolve.call(this, value);
      this.actualResolve = NO_OP;
      this.shown = false;
    },
    /**
     * @param {UICore.Designer.OpenDataPathSelectorOptions} opts
     */
    open(opts) {
      return new Promise(resolve => {
        const width = +opts.width || 300;
        const position = getPopupPosition({
          anchor: opts.place,
          width,
          container: this.designer,
          height: 500
        });
        this.searchKey = '';
        this.width = width;
        this.x = position.x;
        this.y = position.y;
        this.showAllNodes = false;
        this.shown = true;
        this.currentDataPath = opts.currentDataPath || '';
        this.userCustomFilter = opts.filter;
        this.selectorOnly = !!opts.selectorOnly;
        this.actualResolve = resolve;
        this.$nextTick(() => {
          var _this$$refs$searchKey;
          (_this$$refs$searchKey = this.$refs.searchKeyInput) === null || _this$$refs$searchKey === void 0 || _this$$refs$searchKey.focus();
          const scrollContainer = this.$el.querySelector('.ucd-listWithCatalogue-groupContainer');
          const currentItem = this.$el.querySelector('.ucd-dataPathSelectPopover-treeNode.isCurrent');
          if (currentItem && scrollContainer) {
            const relRect = getOffsetRect(currentItem, scrollContainer);
            if (relRect.top > scrollContainer.offsetHeight) {
              scrollContainer.scrollTo(0, relRect.y);
            }
          }
          this.locateCurrentNode();
        });
      });
    },
    async handleCreateState() {
      this.creating = true;
      const res = await this.designer.openCreateStateVariableDialog({
        id: this.currentDataPath || 'foobar',
        windowTitle: '创建页面变量(state) 并绑定到组件',
        place: new DOMRect(this.x - 600, this.y)
      });
      await delay(250);
      this.creating = false;
      this.resolve(res.dataPath);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.shown ? _c("GlobalClickGuard", {
    staticClass: "ucd-dataPathSelectPopover",
    style: {
      left: this.x + "px",
      top: this.y + "px",
      width: this.width + "px"
    },
    attrs: {
      "tag-name": "div",
      "guard-enable": !_vm.creating
    },
    on: {
      cancel: function () {
        _vm.resolve(null);
      }
    }
  }, [_vm.selectorOnly ? _c("div", {
    staticClass: "ucd-dataPathSelectPopover-header"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchKey,
      expression: "searchKey"
    }],
    ref: "searchKeyInput",
    staticClass: "uc-inputbox ucd-dataPathSelectPopover-searchKey",
    attrs: {
      placeholder: _vm.currentDataPath || "输入关键词或 path 搜索"
    },
    domProps: {
      value: _vm.searchKey
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.searchKey = $event.target.value;
      }
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "ucd-dataPathSelectPopover-searchIcon"
  }, [_c("i", {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c("button", {
    staticClass: "uc-button ucd-dataPathSelectPopover-cancelButton",
    attrs: {
      title: "取消"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.resolve(null);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _c("div", {
    staticClass: "ucd-dataPathSelectPopover-header"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentDataPath,
      expression: "currentDataPath"
    }],
    ref: "searchKeyInput",
    staticClass: "uc-inputbox ucd-dataPathSelectPopover-pathInput",
    attrs: {
      spellcheck: "false",
      placeholder: "输入DataPath 或从下面选择"
    },
    domProps: {
      value: _vm.currentDataPath
    },
    on: {
      keypress: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        $event.preventDefault();
        return _vm.resolve(_vm.currentDataPath);
      },
      input: function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.currentDataPath = $event.target.value;
      }
    }
  }), _vm._v(" "), _c("button", {
    staticClass: "uc-button isPrimary",
    attrs: {
      title: "确定"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.resolve(_vm.currentDataPath);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm.displayCreateButton ? _c("button", {
    staticClass: "uc-button ucd-dataPathSelectPopover-addButton",
    attrs: {
      title: "新建变量"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.handleCreateState();
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c("button", {
    staticClass: "uc-button ucd-dataPathSelectPopover-cancelButton",
    attrs: {
      title: "取消"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.resolve(null);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "ucd-dataPathSelectPopover-header2"
  }, [_c("a-checkbox", {
    model: {
      value: _vm.showOriginalName,
      callback: function ($$v) {
        _vm.showOriginalName = $$v;
      },
      expression: "showOriginalName"
    }
  }, [_vm._v("\n      英文名\n    ")]), _vm._v(" "), _c("a-checkbox", {
    model: {
      value: _vm.showAllNodes,
      callback: function ($$v) {
        _vm.showAllNodes = $$v;
      },
      expression: "showAllNodes"
    }
  }, [_vm._v("\n      全部节点\n    ")]), _vm._v(" "), _c("a", {
    attrs: {
      href: "#"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.locateCurrentNode.apply(null, arguments);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-dot-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      找到当前节点\n    ")])], 1), _vm._v(" "), _c("UcdDataSourceTree", {
    staticClass: "ucd-dataPathSelectPopover-tree",
    attrs: {
      "indent-width": "24px",
      "search-keyword": _vm.filteredDataSource,
      "hide-catalogue": true,
      sticky: false
    },
    scopedSlots: _vm._u([{
      key: "node",
      fn: function (node) {
        return [_c("DSTreeNode", {
          key: node.dataPath,
          ref: "node:" + node.dataPath,
          staticClass: "ucd-dataPathSelectPopover-treeNode",
          class: {
            isSelectable: _vm.checkBindableOfTreeNode(node),
            isCurrent: node.dataPath === _vm.currentDataPath
          },
          attrs: {
            name: _vm.showOriginalName ? node.id : node.name,
            stub: node.stub,
            "data-path": node.dataPath,
            depth: node.depth,
            expandable: node.expandable,
            expanded: node.expanded,
            "toggle-expansion": node.toggleExpansion,
            "line-expansion": false,
            "show-object-value": false,
            draggable: false
          },
          on: {
            click: _vm.handleTreeNodeClick
          }
        })];
      }
    }], null, false, 746049645)
  }, [_c("div", {
    attrs: {
      slot: "empty"
    },
    slot: "empty"
  }, [_c("a-empty", {
    staticStyle: {
      margin: "10px auto"
    }
  }), _vm._v(" "), _c("ul", [_c("li", [_vm._v("如果确定变量存在，直接在上方输入数据路径，例如 "), _c("code", [_vm._v("data.foo.bar")]), _vm._v(" 后按下 "), _c("i", {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c("li", [_vm._v("可在编辑器左侧 “数据源” 面板添加新的数据源")])])], 1)])], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/DataPathSelectPopover.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);